import { Edit24 } from "@carbon/icons-react";

import React, { useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../components/Buttons/SubmitButton";
import Card from "../../components/Card/Card";

const SubmittedCandidaturePage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);

  const navigate = useNavigate();

  return (
    <Card title="Candidatura Submetida">
      <p>A tua candidatura foi submetida com sucesso!</p>
      <SubmitButton
        type="button"
        className="mt-2 emprega-bg-green"
        label={"Consultar Candidatura"}
        icon={Edit24}
        onClick={() => navigate("../candidature/" + uuid)}
      />
    </Card>
  );
};
export default SubmittedCandidaturePage;
